import { render } from "./AdminViewImage.vue?vue&type=template&id=68352d96&scoped=true"
import script from "./AdminViewImage.vue?vue&type=script&lang=js"
export * from "./AdminViewImage.vue?vue&type=script&lang=js"

import "./AdminViewImage.vue?vue&type=style&index=0&id=68352d96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68352d96"]])

export default __exports__